import { useState, useEffect } from 'react';

import { useCaptureException, ZBError } from '@zenbusiness/application-commons-logging';

export default function useAnchorElement(entityMenuRef, buttonRef) {
  const captureException = useCaptureException();
  const [anchorElement, setAnchorEl] = useState(null);

  const onButtonClick = (event) => {
    buttonRef.current.blur();
    setAnchorEl(event.currentTarget);
  };

  const onMenuClose = () => {
    buttonRef.current.blur();
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!entityMenuRef.current) {
      return;
    }

    try {
      if (anchorElement) {
        entityMenuRef.current.querySelector('a')?.focus();
      }
    } catch (err) {
      captureException(new ZBError(err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorElement, entityMenuRef.current]);

  return {
    anchorElement,
    onButtonClick,
    onMenuClose
  };
}
